import React from 'react';
import Style from './style.module.css';

const Navbar = () => {
  return (
    <nav className={Style.navBar}>
      <ul className={Style.navList}>
        <div className={Style.logoContainer}>
          <a href="https://bethevariable.com/">
            <img alt="Perform Logo" src="/logo.png" width="100" height="100" />
          </a>
        </div>

        <li>
          <ul className={Style.buttonContainer}>
            <li className={Style.navButton}>
              <a
                href="https://bethevariable.com/"
                className={Style.navLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                About Us
              </a>
            </li>

            <li className={Style.navButton}>
              <a
                href="https://bethevariable.com/perform-reports-actionable-insights-push-of-a-button/"
                className={Style.navLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                About the App
              </a>
            </li>

            <li className={Style.navButton}>
              <a
                href="https://bethevariable.com/contact-us/"
                className={Style.navLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
